module.exports = __webpack_public_path__ + "static/media/anali100x.1a898281.png";